import { useTheme } from '@mui/material/styles';
import { FC } from 'react';

import SallingLogo from '@/assets/logos/logo_salling.svg?react';
import {
  BrandLogoProps,
  DEFAULT_BRAND_LOGO_HEIGHT,
} from '@/components/shared/logos/props';

const DEFAULT_PRIMARY_COLOR = '#231F20';

const BrandLogoSalling: FC<BrandLogoProps> = ({
  themeAware = true,
  primaryColor,
  borderlessScale = false,
  height = DEFAULT_BRAND_LOGO_HEIGHT,
  style,
  ...other
}) => {
  const theme = useTheme();
  let color = primaryColor ?? DEFAULT_PRIMARY_COLOR;
  if (themeAware && !primaryColor && theme.palette.mode === 'dark') {
    color = '#fff';
  }

  return <SallingLogo {...other} height={height} style={{ ...style, color }} />;
};

export default BrandLogoSalling;
